export default __webpack_public_path__ + "static/media/Belt of the Crawling Chaos.0e469c50.jpg";